import React from 'react';
import { DSRadio } from '@elliemae/ds-form';
import { DSHeader } from '@elliemae/ds-header';
import type { ChannelOption } from '../ScenarioHeader/constants';
import {
  ChannelSelectContainer,
  ChannelOptionsWrapper,
  ChannelOptionCard,
} from './styled';

export interface ChannelSelectCardProps {
  channels: ChannelOption[];
  selectedChannel: ChannelOption | null;
  onChannelSelect: (channel: ChannelOption) => void;
}

export const ChannelSelectCard: React.FC<ChannelSelectCardProps> = ({
  channels,
  selectedChannel,
  onChannelSelect,
}) => {
  return (
    <ChannelSelectContainer>
      <DSHeader text="Select a Channel" fontSize="16px" />
      <ChannelOptionsWrapper>
        {channels.map((channel) => (
          <ChannelOptionCard
            key={channel.id}
            isSelected={selectedChannel?.id === channel.id}
            onClick={() => onChannelSelect(channel)}
          >
            <DSRadio
              name="channel-select"
              labelText={channel.label}
              value={channel.id}
              checked={selectedChannel?.id === channel.id}
              onChange={() => onChannelSelect(channel)}
            />
          </ChannelOptionCard>
        ))}
      </ChannelOptionsWrapper>
    </ChannelSelectContainer>
  );
};

export default ChannelSelectCard;
